"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = sortAscending;
function sortAscending(list) {
    return list.sort(function (a, b) { return a - b; });
}
//# sourceMappingURL=sortAscending.js.map